var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 23",
    d: "M12.4004 2.53174C12.7401 2.1096 13.3628 2.03898 13.7402 2.42776C14.8146 3.53447 15.5513 4.93395 15.8506 6.4612C16.2132 8.31095 15.911 10.2293 14.9972 11.878C14.0835 13.5267 12.617 14.7998 10.8562 15.4727C9.09551 16.1457 7.1537 16.1754 5.37325 15.5565C3.59281 14.9376 2.08808 13.7098 1.12444 12.0898C0.1608 10.4698 -0.199859 8.56157 0.106068 6.7016C0.411994 4.84164 1.36486 3.14944 2.79661 1.92343C3.97874 0.911163 5.42465 0.270382 6.9538 0.0686876C7.49099 -0.00216783 7.93567 0.439526 7.94028 0.981352C7.94489 1.52318 7.50646 1.95804 6.97252 2.05025C5.90671 2.23431 4.90351 2.70257 4.07287 3.41385C2.99229 4.33916 2.27314 5.61631 2.04225 7.02007C1.81136 8.42383 2.08355 9.86403 2.81084 11.0867C3.53812 12.3094 4.67378 13.236 6.01753 13.7031C7.36128 14.1702 8.82681 14.1478 10.1557 13.6399C11.4845 13.132 12.5914 12.1711 13.281 10.9268C13.9706 9.68253 14.1987 8.23468 13.9251 6.83863C13.7147 5.76548 13.2183 4.77592 12.4964 3.97045C12.1348 3.56693 12.0607 2.95388 12.4004 2.53174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M16.5879 3.05371L12.5341 1.90965L11.39 5.96347",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.06f4376df9c01a0a6a1b2f0cf90d39e3.svg";
export { ForwardRef as ReactComponent };